'use client'

/**
 * Shared context for the IRL widget-of-widget pair.
 *
 * INFLUENCER_SECTION is the container: it does the single batched product fetch, owns the shoppable
 * popup, and renders the Swiper around the pre-rendered INFLUENCER_CARD children. Those list-level
 * concerns can't live on an individual card, so the section publishes them here and each
 * INFLUENCER_CARD child reads its own product details + the popup opener by its card id.
 */

import { createContext, useContext } from 'react'

import type { InfluencerCardProductDetails } from '@src/quince-components/src/atoms/influencerCard/InfluencerCard'

export interface InfluencerCardContextValue {
  isB2BSelfService: boolean
  // Maps keyed exactly like useInfluencerCardProducts returns them (spid number / contentful id).
  spidToProductMap: Record<number, InfluencerCardProductDetails>
  contentfulProductIdToProductMap: Record<string, InfluencerCardProductDetails>
  productViewTracker?: string
  // Open the shoppable popup positioned on this card. The section binds it to the card's index
  // per-card (the nested INFLUENCER_CARD widgets have empty ids, so an id lookup can't locate them).
  openPopup: () => void
}

const InfluencerCardContext = createContext<InfluencerCardContextValue | null>(null)

export const InfluencerCardContextProvider = InfluencerCardContext.Provider

export const useInfluencerCardContext = (): InfluencerCardContextValue | null => useContext(InfluencerCardContext)
